import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {useBasketMovSection} from '../hooks/useGetBasketPageSection';
import {BasketMOVProps, BasketMOVView} from './BasketMOVView';

export const BasketMOV: React.FC<
  Omit<BasketMOVProps, 'refetchBasketSection'>
> = props => {
  const basketMovSectionRequest = useBasketMovSection();

  /**
   * Passing down the refetch function for the GetBasketPageBulk endpoint, since
   * the hardcoded stale time of zero, in combination with the disableViewWhileRefetching
   * prop, create an endless loop when trying to get any section of the GetBasketPageBulk request
   * within any component of this view. If any component in this view make a call again to
   * this EP, the request will be fetching again, and since the stale time is always zero,
   * the endpoint will be called endlessly.
   */
  const refetchBasketSection = async () => {
    await basketMovSectionRequest.refetch();
  };

  return (
    <DataFetcher
      request={basketMovSectionRequest}
      Error={() => null}
      View={BasketMOVView}
      viewProps={{...props, refetchBasketSection}}
      disableViewWhileRefetching
    />
  );
};
